import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './FEHero.css';

const FEHero = () => {
    const [formData, setFormData] = useState({
        nombre: '',
        correo: '',
        telefono: '',
        empresa: '',
    });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => emailjs.init("OR-hFrEcD28bt5k1j"), []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await emailjs.send("service_yh80bao", "template_few544q", {
                fullName: `${formData.nombre} — ${formData.empresa}`,
                email: formData.correo,
                phone_number: formData.telefono,
                selectedService: 'Facturación Electrónica',
                selectedPlan: 'Solicitud de demo FE',
            });
            setSubmitted(true);
        } catch (err) {
            setError('Ha ocurrido un error. Intente más tarde o escriba al WhatsApp 809-605-0699.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section id="fe-hero" className="fe-hero">
            <div className="container">
                <div className="row align-items-center">

                    {/* Left column — headline */}
                    <div className="col-lg-7 fe-hero__left">
                        <div className="fe-hero__badge mb-3">
                            <span className="fe-hero__badge-tag">
                                <i className="fas fa-check-circle"></i> Facturación Electrónica
                            </span>
                        </div>

                        <h1 className="fe-hero__headline">
                            Factura y Contabiliza,{' '}
                            <span className="fe-hero__headline-accent">
                                controla todo tu negocio
                            </span>
                        </h1>

                        <p className="fe-hero__subtitle">
                            Emite Comprobantes Fiscales Electrónicos (e-CF) y llega el control de tu negocio,
                            con un sistema ERP contable y modular, transmisión automática a la DGII. Cumple con la Ley 32-23
                            antes del plazo obligatorio sin complicaciones y sin sorpresas.
                        </p>

                        <div className="fe-hero__trust-row">
                            <div className="fe-hero__trust-item">
                                <i className="fas fa-signature fe-accent-text"></i>
                                <span>Firma digital integrada</span>
                            </div>
                            <div className="fe-hero__trust-item">
                                <i className="fas fa-file-code fe-accent-text"></i>
                                <span>Formato XML validado</span>
                            </div>
                            <div className="fe-hero__trust-item">
                                <i className="fas fa-exchange-alt fe-accent-text"></i>
                                <span>Transmisión a DGII en tiempo real</span>
                            </div>
                        </div>
                    </div>

                    {/* Right column — lead capture form */}
                    <div className="col-lg-5 mt-5 mt-lg-0 fe-hero__right">
                        <div className="fe-hero__form-card">
                            <div className="fe-hero__form-header">
                                <h3 className="fe-hero__form-title">Solicita tu demostración</h3>
                                <p className="fe-hero__form-subtitle">
                                    Certifícate antes del plazo obligatorio gratis.
                                </p>
                            </div>

                            {submitted ? (
                                <div className="fe-hero__success">
                                    <div className="fe-hero__success-icon">
                                        <i className="fas fa-check-circle"></i>
                                    </div>
                                    <h4>¡Gracias, {formData.nombre.split(' ')[0]}!</h4>
                                    <p>
                                        Hemos recibido tus datos. Un asesor te contactará dentro de
                                        las próximas 24 horas para activar tu cuenta.
                                    </p>
                                    <a
                                        href="https://wa.me/18096050699"
                                        className="btn btn-fe-primary w-100 mt-2"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fab fa-whatsapp mr-2"></i>Hablar por WhatsApp
                                    </a>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit} className="fe-hero__form" noValidate>
                                    <div className="form-group fe-hero__form-group">
                                        <label htmlFor="fe-nombre">Nombre completo</label>
                                        <input
                                            id="fe-nombre"
                                            type="text"
                                            name="nombre"
                                            className="form-control fe-hero__input"
                                            placeholder="Juan Pérez"
                                            value={formData.nombre}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group fe-hero__form-group">
                                        <label htmlFor="fe-correo">Correo electrónico</label>
                                        <input
                                            id="fe-correo"
                                            type="email"
                                            name="correo"
                                            className="form-control fe-hero__input"
                                            placeholder="juan@empresa.com"
                                            value={formData.correo}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group fe-hero__form-group">
                                        <label htmlFor="fe-telefono">Teléfono / WhatsApp</label>
                                        <input
                                            id="fe-telefono"
                                            type="tel"
                                            name="telefono"
                                            className="form-control fe-hero__input"
                                            placeholder="+1 (809) 000-0000"
                                            value={formData.telefono}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group fe-hero__form-group mb-4">
                                        <label htmlFor="fe-empresa">Nombre de empresa</label>
                                        <input
                                            id="fe-empresa"
                                            type="text"
                                            name="empresa"
                                            className="form-control fe-hero__input"
                                            placeholder="Mi Empresa S.R.L."
                                            value={formData.empresa}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-fe-primary w-100 fe-hero__submit-btn"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm mr-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Procesando...
                                            </>
                                        ) : (
                                            <>
                                                Comenzar ahora{' '}
                                                <i className="fas fa-arrow-right ml-2"></i>
                                            </>
                                        )}
                                    </button>

                                    {error && (
                                        <p className="text-danger text-center mt-2 mb-0 font-14">
                                            {error}
                                        </p>
                                    )}

                                    <p className="fe-hero__form-disclaimer">
                                        <i className="fas fa-lock mr-1"></i>
                                        Tus datos están protegidos. No spam.
                                    </p>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FEHero;
